// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    const scrollcontent = accordion.getAttribute("js-acc-single-trigger-scroll") || null;
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
      intro.onclick = (e) => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(e.target.closest('[js-acc-item]'));
        }
      };
    }
  });   
}

(function() {
  faq_taggol();  
  (document.querySelector("[data-header-tans]") || null) && document.body.classList.add("header-transparent");
})();

// Menu Hover Start
let items = document.querySelector(".header__inline-menu").querySelectorAll("details") || null;
  if(items){
      items.forEach(item => {
       item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
         item.querySelector("ul, .megamenu-image-block.mega_menu_2").addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
         item.addEventListener("mouseleave", () => {
           item.removeAttribute("open");
         });
       });
      });
  }
// Menu Hover end

// =============== mobile close click event


 const closeBtn = document.querySelector("drawer-close");
const menuDrawer = document.querySelector(".menu-drawer-container summary");

if (closeBtn && menuDrawer) {
  closeBtn.addEventListener("click", function () {
    console.log(closeBtn,"closeBtn")
    menuDrawer.click();
  });
}

//faq section
const faq_main_wap = document.querySelector('[faq_main_wap]') || null;
if (faq_main_wap) {
  const faq_toggles = faq_main_wap.querySelectorAll('[data-act-title]') || null;
  const faq_content_wap = faq_main_wap.querySelector('[faq_content_wap]') || null;
  const faq_content_tabs = faq_content_wap.querySelectorAll('.tabs') || null;
  const faq_dropdown = faq_main_wap.querySelector('.faq-category-dropdown') || null;
  const faq_selected = faq_main_wap.querySelector('.faq-category-selected') || null;
  const mian_tag = document.querySelector('.faq-category')|| null;
  const content = document.querySelector("[js-acc-single-content]");
  
  if (faq_content_wap) {
    faq_toggles.forEach((faq) => {
      faq.addEventListener('click', (event) => {
        faq_content_tabs.forEach((tab) => {
          tab.classList.remove('active');
          tab.style.display = 'none';
        });

        faq_toggles.forEach((toggle) => {
          toggle.classList.remove('active-tab');
        });

        const targetSelector = event.currentTarget.getAttribute('data-act-title');
        const targetTab = faq_content_wap.querySelector(targetSelector);

        if (targetTab) {
          targetTab.classList.add('active');
          targetTab.style.display = 'block';
          
         
        }
        event.currentTarget.classList.add('active-tab');
        

        if (faq_dropdown && faq_selected) {
          faq_selected.textContent = event.currentTarget.textContent.trim();
          faq_dropdown.classList.remove('open'); // Adjust class based on your dropdown open state
          mian_tag.classList.remove('active');
          if(content){
            content.style.maxHeight = null;
          }
        }
      });
    });

    if (faq_dropdown) {
      faq_dropdown.addEventListener('click', () => {
        faq_dropdown.classList.toggle('open'); // Add/remove "open" class for the dropdown
      });
    }
  }
}
//faq section end


// megamenu hover image and menu code
//document.addEventListener("DOMContentLoaded", function () {
  // Variables

  const listItems = document.querySelectorAll(".header_custom_d li");
  const imageBlocks = document.querySelectorAll(".col_images_da");
  const childLinks = document.querySelectorAll(".mega-menu__item");
  const sublists = document.querySelectorAll(".mega-menu__sublist");
  const megaMenu = document.querySelector(".mega-menu__sublist-wrap");
  const mainMenu = document.querySelector(".header_custom_d");

  // Default first image
  const firstImage = document.querySelector(".col_images_da");
  if (firstImage) firstImage.classList.remove("hidden");

  // Hide all grandchild lists initially
  sublists.forEach((sub) => (sub.style.display = "none"));


  // Handle Hover on Child Links

  childLinks.forEach((link) => {
    const handle = link.getAttribute("data-child");

    link.addEventListener("mouseenter", () => {
      // --- Handle Grandchild Menu ---
      sublists.forEach((sub) => (sub.style.display = "none"));
      const target = document.querySelector(`.mega-menu__sublist[data-sublist="${handle}"]`);
      if (target) target.style.display = "block";

      // --- Handle Image ---
      const linkAnchor = link.querySelector(".custom_main_link");
      if (!linkAnchor) return;

      const targetTitle = linkAnchor.getAttribute("link_title");
      imageBlocks.forEach((img) => img.classList.add("hidden"));

      const matchedImage = document.querySelector(
        `.col_images_da[link_title="${targetTitle}"]`
      );
      if (matchedImage) matchedImage.classList.remove("hidden");
    });
  });


  // Reset When Leaving Areas

  const hideAllGrandchildsAndResetImage = () => {
    sublists.forEach((sub) => (sub.style.display = "none"));
    imageBlocks.forEach((img) => img.classList.add("hidden"));
    if (firstImage) firstImage.classList.remove("hidden");
  };

  if (megaMenu) {
    megaMenu.addEventListener("mouseleave", hideAllGrandchildsAndResetImage);
  }
  // if (mainMenu) {
  //   mainMenu.addEventListener("mouseleave", hideAllGrandchildsAndResetImage);
  // }
//}); // end megamenu

// update price on product
function updaprice() {
  const taxToggle = document.querySelector('#on');
  if (!taxToggle) return; // Prevent error if toggle not found

  const priceElements = document.querySelectorAll('.price-item');
  if (!priceElements.length) return; // No prices to update

  // Store original prices only once
  priceElements.forEach(el => {
    if (!el.dataset.originalPrice) {
      const text = el.textContent.replace(/[^\d,.-]/g, '').replace(',', '.'); 
      el.dataset.originalPrice = parseFloat(text);
    }
  });

  // Remove any previous listener before adding new one (avoid duplicates)
  taxToggle.removeEventListener('change', handleTaxChange);
  taxToggle.addEventListener('change', handleTaxChange);
}

function handleTaxChange() {
  const taxToggle = document.querySelector('#on');
  const priceElements = document.querySelectorAll('.price-item');
  const taxText = document.querySelector('[taxText]');
  const addhidden = document.querySelector('[addhidden]');

  priceElements.forEach(el => {
    let originalPrice = parseFloat(el.dataset.originalPrice);
    if (isNaN(originalPrice)) return;

    let newPrice = originalPrice;
    if (taxToggle.checked) {
      newPrice = originalPrice * 0.81; // subtract 19%
    }

    el.textContent = newPrice.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + '€';
  });

  if(taxText && addhidden){
    taxText.classList.toggle('hidden', !taxToggle.checked);
    addhidden.classList.toggle('hidden');
  }

}
updaprice();
// end update price

// media swiper only mobile view 

  if (window.matchMedia) {
  const mq = window.matchMedia("(min-width: 750px)");
  mq.addListener(handleWidthChange);
  handleWidthChange(mq);
}

function handleWidthChange(mq) {
  const sliderEl_div = document.querySelector('[data-main-pdp-swiper]');
  if (!sliderEl_div) return; // exit if no slider on this page

  const sliderEl = document.querySelector('[data-pdp-main-slider]');
  if (!sliderEl) return;

  const optionsAttr = sliderEl.getAttribute('data-slider-options');

  if (mq.matches) {
    // Desktop: destroy swiper if exists
    if (sliderEl_div.swiper) {
      sliderEl_div.swiper.destroy(true, true);
    }
  } else {
    // Mobile: initialize swiper if not already initialized
    if (!sliderEl_div.swiper) {
      if (optionsAttr) {
        const options = JSON.parse(optionsAttr);
        new Swiper(sliderEl_div, options);
      }
    }
  }
}// end swiper code

// tab PDP

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".tab-content");

  if (buttons.length > 0) {
    buttons[0].classList.add("active");
    contents[0].classList.add("active");
  }

  buttons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const tabId = btn.dataset.tab;

      buttons.forEach((b) => b.classList.remove("active"));
      contents.forEach((c) => c.classList.remove("active"));

      btn.classList.add("active");
      document.getElementById(tabId).classList.add("active");
    });
  });
});

// media img load more btn set 

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".show-more-media-btn");
  if (!btn) return;

  btn.addEventListener("click", function () {
    document.querySelectorAll(".hidden-extra").forEach(img => {
      img.classList.remove("hidden-extra");
    });
    btn.style.display = "none";
  });
});

// cart-drawer dropdwan option 
document.addEventListener("click", function (e) {
  const dropBtn = e.target.closest(".drop-value-option");
  if (!dropBtn) return;

  // Get the container of this cart line item
  const itemContainer = dropBtn.closest(".cart-item, cart-drawer-item");

  if (!itemContainer) return;

  // Select ALL dropdown boxes inside this cart item
  const optionBoxes = itemContainer.querySelectorAll(".option-values");

  optionBoxes.forEach((box) => {
    box.classList.toggle("active");
    box.classList.toggle("hidden");
  });

  // Also toggle the clicked button
  dropBtn.classList.toggle("active");
});

// blog sticky content 

  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.sticky-block-content ul li');

    items.forEach(item => {
      item.addEventListener('click', function(e) {
        // Remove active from all
        items.forEach(i => i.classList.remove('active'));

        // Add active to clicked
        this.classList.add('active');
      });
    });
  });

// serach bar header menu drawer
  document.addEventListener('click', function (e) {
  const resetBtn = e.target.closest('.reset__button');
  if (!resetBtn) return;

  // 🔥 Stop header / drawer toggle
  e.stopPropagation();
}, true); // <-- capture phase (important)


// dropdwan logic for the messe-ratgeber-1 page 
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sticky-block-content').forEach(parent => {

    const accItem = parent.querySelector('[js-acc-item]');
    const selectedText = parent.querySelector('.sticky-block-content-selected');
    const dropdown = parent.querySelector('[js-acc-single-content]');

    if (!accItem || !selectedText || !dropdown) return;

    dropdown.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {

        // 1️⃣ Set selected text
        selectedText.textContent = link.textContent.trim();

        // 2️⃣ Close dropdown (use existing system)
        accItem.classList.remove('active');
        dropdown.style.maxHeight = null; // important for inline style reset

        // ❗ No preventDefault → scroll works normally
      });
    });

  });
});
//end code messe-ratgeber-1

//popup code

document.addEventListener("DOMContentLoaded", function() {

  const popup = document.getElementById("inquiryPopup");
  const popupInner = document.querySelector(".custom-popup-inner");
  const openBtns = document.querySelectorAll("#openInquiryPopup");
  const closeBtn = document.getElementById("closeInquiryPopup");

  if (!popup || !popupInner) return;

  // ======================
  // OPEN POPUP (Multiple buttons)
  // ======================
  openBtns.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation(); // drawer close logic stop kare
      popup.classList.add("active");
      document.body.style.overflow = "hidden";
    });
  });

  // ======================
  // CLOSE BUTTON
  // ======================
  if (closeBtn) {
    closeBtn.addEventListener("click", function(e) {
      e.stopPropagation();
      closePopup();
    });
  }

  // ======================
  // OUTSIDE CLICK CLOSE
  // ======================
  popup.addEventListener("click", function(e) {
    if (!popupInner.contains(e.target)) {
      closePopup();
    }
  });

  function closePopup() {
    popup.classList.remove("active");
    document.body.style.overflow = "";
  }

});//end popup code 

//  custom bundal code end
function custom_addtocart_fun(product,open_drawer){
  console.log("product",product);
      fetch(`${routes.cart_add_url}`,{ 
              method: 'POST',
              headers: { "Accept": "application/json", "Content-Type": "application/json" },
              body: JSON.stringify(product)
        })
        .then(response => response.json()).then(response => {     
          console.log(response);   
        })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally((e) => {
          // console.log("finally");
          if(open_drawer){
            const this_cartDrawer = document.querySelector('cart-drawer');
           // console.log("this_cartDrawer",this_cartDrawer);
            this_cartDrawer.refresh(true);
          }
        });
    }

// upsell product variant 

document.querySelectorAll('.addon-product-item').forEach(item => {

  const select = item.querySelector('.variant-select');
  const checkbox = item.querySelector('.addon-product-checkbox');

  if (select && checkbox) {

    select.addEventListener('change', function () {

      const selectedVariantId = this.value;

      // 👉 update variant id
      checkbox.setAttribute('data-variant-id', selectedVariantId);

      // 👉 auto check checkbox
      checkbox.checked = true;

      console.log("Selected Variant ID:", selectedVariantId);
    });

  }

});
//upsell change box
document.querySelectorAll('.addon-product-checkbox').forEach(checkbox => {

  checkbox.addEventListener('change', function () {

    const item = this.closest('.addon-product-item');
    const select = item.querySelector('.variant-select');

    if (select) {
      this.setAttribute('data-variant-id', select.value);
    }

  });

}); // endupsell

// js using live product option app value inside set a info text
function initOptionTooltip(){

  const jsonElement = document.getElementById('option-tooltips-data');
  if(!jsonElement) return;

  const tooltipData = JSON.parse(jsonElement.textContent);

  // normalize function
  function normalize(str){
    return str
      .toLowerCase()
      .replace(/[-_]/g, ' ')        // dash → space
      .replace(/\s+/g, ' ')        // multiple space → single
      .replace(/[^a-z0-9 ]/g, '')  // remove special chars
      .trim();
  }

  const selects = document.querySelectorAll('select[name^="properties["]');

  selects.forEach(select => {

    let nameAttr = select.getAttribute("name") || "";

    let optionName = nameAttr.match(/properties\[(.*?)\]/);
    if(!optionName) return;

    optionName = optionName[1];

    optionName = optionName.replace(/[0-9-]/g,'').trim();

    // normalize compare for option name
    if(normalize(optionName) !== normalize("Auswahl Textilart")) return;

    const wrapper = select.closest('.cl-po--option');
    if(!wrapper) return;

    let icon = wrapper.querySelector('.option-tooltip-icon');

    if(!icon){

      icon = document.createElement("span");
      icon.className = "option-tooltip-icon";

      icon.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="12.257" height="12.257" viewBox="0 0 12.257 12.257">
        <g transform="translate(-0.8 -0.8)">
          <path d="M6.928.8a6.128,6.128,0,1,0,6.128,6.128A6.126,6.126,0,0,0,6.928.8Zm0,11.047a4.919,4.919,0,1,1,4.919-4.919A4.938,4.938,0,0,1,6.928,11.847Z" fill="#b40001"/>
          <path d="M15.547,13.6H14.9a.19.19,0,0,0-.2.2v3.669a.19.19,0,0,0,.2.2h.645a.19.19,0,0,0,.2-.2V13.8A.19.19,0,0,0,15.547,13.6Z" transform="translate(-8.296 -7.639)" fill="#b40001"/>
          <path d="M14.4,8.494a.668.668,0,0,0-.2.524.766.766,0,0,0,.2.524.65.65,0,0,0,.524.242.742.742,0,0,0,.524-1.25A.72.72,0,0,0,14.4,8.494Z" transform="translate(-7.997 -4.468)" fill="#b40001"/>
        </g>
      </svg>
      <div class="option-tooltip-text"></div>
      `;

      wrapper.appendChild(icon);
    }

    const tooltip = icon.querySelector('.option-tooltip-text');

    function updateTooltip(){

      const val = normalize(select.value);

      let matchedKey = Object.keys(tooltipData).find(key => {
        const normalizedKey = normalize(key);

        // 🔥 smart match (both direction)
        return val.includes(normalizedKey) || normalizedKey.includes(val);
      });

      if(!matchedKey){
        icon.style.display = "none";
        return;
      }

      icon.style.display = "inline-block";
      tooltip.textContent = tooltipData[matchedKey];

    }

    select.addEventListener("change", updateTooltip);

    updateTooltip();

  });

}

// observer (cleaned duplicate)
const observer = new MutationObserver(function(){

  const select = document.querySelector('select[name*="Auswahl Textilart"]');
  if(!select) return;

  if(select.dataset.tooltipInit === "true") return;

  initOptionTooltip();

  select.dataset.tooltipInit = "true";

});

observer.observe(document.body,{
  childList:true,
  subtree:true
}); // endcode app option


// PDP light shot app option 
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.cl-po--swatch-item');
  if (!swatch) return;

  const container = swatch.closest('.cl-po--swatch-container');
  if (!container) return;

  const allSwatches = [...container.querySelectorAll('.cl-po--swatch-item')];
  const currentIndex = allSwatches.indexOf(swatch); // 🔥 clicked index

  const images = container.querySelectorAll('img');
  if (!images.length > 0) return;

  let slides = '';

  images.forEach(img => {
    slides += `
      <div class="swiper-slide">
        <img src="${img.src}" />
      </div>
    `;
  });

  createSwiperPopup(slides, currentIndex);
});



function createSwiperPopup(slides,startIndex) {
    console.log("slides",slides);
  // Prevent duplicate popup
  if (document.querySelector('.custom-swiper-popup')) return;

  const popup = document.createElement('div');
  popup.className = 'custom-swiper-popup';

  popup.innerHTML = `
    <div class="swiper-overlay"></div>

    <div class="swiper-container-wrapper">
      <button class="swiper-close">✕</button>

      <div class="swiper mySwiper">
        <div class="swiper-wrapper">
          ${slides}
        </div>

        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  `;
console.log("popup",popup);
  document.body.appendChild(popup);
  document.body.classList.add('custom-lightbox-popup');

  // Init Swiper
  new Swiper('.mySwiper', {
    initialSlide: startIndex,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}


document.addEventListener('click', function (e) {
  if (
    e.target.classList.contains('swiper-close') ||
    e.target.classList.contains('swiper-overlay')
  ) {
    const popup = document.querySelector('.custom-swiper-popup');
    if (popup){
      popup.remove();
      document.body.classList.remove('custom-lightbox-popup');
    }
  }
});


(function () {
 // document.addEventListener('DOMContentLoaded', function () {
    const backToTopBtn = document.querySelector('#back-to-top-button');
    console.log("backToTopBtn",backToTopBtn);
    // 👉 agar button nathi to code run na karo
    if (!backToTopBtn) return;

    window.addEventListener('scroll', function () {
      console.log("backToTopBtn");
      const scrollTop = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      const scrollableHeight = documentHeight - windowHeight;
      const halfPage = scrollableHeight / 2;

      if (scrollTop >= halfPage) {
        backToTopBtn.classList.add('active');
      } else {
        backToTopBtn.classList.remove('active');
      }
    });

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('#back-to-top-button');
      if (!btn) return;

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
 // });
})();

//app all option value pass in input 
// ================== UPDATE FUNCTIONS ==================
// ================== COMMON HELPER ==================
function setValue(selector, inputId, type = 'value') {
  const el = document.querySelector(selector);
  const hidden = document.getElementById(inputId);

  if (!el || !hidden) return;

  if (type === 'checked') {
    const checked = document.querySelector(`${selector}:checked`);
    if (checked) hidden.value = checked.value;
  } else {
    hidden.value = el.value?.trim() || '';
  }
}

// ================== TEXTILART ==================
function updateTextilart() {
  const selects = document.querySelectorAll('select[name^="properties[Auswahl Textilart"]');
  const hidden = document.getElementById('productapp-textilart');
  const ausfuhrung = document.querySelector('input[name="properties[Ausführung]"]:checked');

  if (!hidden) return;

  if (ausfuhrung?.value === 'Ohne Textil (nur Rahmen)') {
    hidden.value = '';
    return;
  }

  let values = [];
  selects.forEach((s, i) => {
    if (s.value) values.push(`Textilart ${i + 1}: ${s.value}`);
  });

  hidden.value = values.join(', ');
}

// ================== BILDDATEI ==================
function updateBilddatei() {
  const containers = document.querySelectorAll('.cl-po--upload-files');
  const hidden = document.getElementById('productapp-bilddatei');

  if (!hidden) return;

  let values = [];
  let count = 1;

  containers.forEach(c => {
    c.querySelectorAll(':scope > div').forEach(item => {
      const text = item.textContent.replace('×', '').trim();
      if (text) values.push(`Bilddatei ${count++}: ${text}`);
    });
  });

  hidden.value = values.join(', ');
}

// ================== OBSERVER ==================
function observeUploads() {
  const containers = document.querySelectorAll('.cl-po--upload-files');

  if (!containers.length) return setTimeout(observeUploads, 500);

  containers.forEach(c => {
    new MutationObserver(updateBilddatei).observe(c, {
      childList: true,
      subtree: true
    });
  });

  updateBilddatei();
}

// ================== DIMENSION (B x H) ==================
function updateDimension() {
  const inputX = document.querySelector('input[name="properties[_Individuelle Maße in cm (B x H)_x]"]');
  const inputY = document.querySelector('input[name="properties[_Individuelle Maße in cm (B x H)_y]"]');

  const hiddenX = document.getElementById('productapp-MaßeX');
  const hiddenY = document.getElementById('productapp-MaßeY');

  if (inputX && hiddenX) hiddenX.value = inputX.value.trim();
  if (inputY && hiddenY) hiddenY.value = inputY.value.trim();
}

// ================== DIMENSION (T) ==================
function updateDimensionT() {
  const inputX = document.querySelector('input[name="properties[_Individuelle Maße in cm (T)_x]"]');
  const hidden = document.getElementById('productapp-Maße-cm');

  if (inputX && hidden) {
    hidden.value = inputX.value.trim();
  }
}

// ================== INIT ==================
function init() {
  const ready = document.querySelector(`
    input[name="properties[Rahmenfarbe]"],
    input[name="properties[Ausführung]"],
    input[name="properties[INDIVIDUELLE RAL FARBE ]"],
    select[name^="properties[Auswahl Textilart"],
    select[name="properties[Druckdatenverarbeitung]"]
  `);

  if (!ready) return setTimeout(init, 500);

  // ================== INITIAL VALUES ==================
  setValue('input[name="properties[Rahmenfarbe]"]', 'productapp-option', 'checked');
  setValue('input[name="properties[Ausführung]"]', 'productapp-ausführung', 'checked');
  setValue('input[name="properties[INDIVIDUELLE RAL FARBE ]"]', 'productapp-farbe');
  setValue('select[name="properties[Druckdatenverarbeitung]"]', 'productapp-druckdatenverarbeitung');

  updateTextilart();
  updateDimension();
  updateDimensionT();

  // ================== EVENTS ==================

  document.addEventListener('change', e => {

    if (e.target.matches('input[name="properties[Rahmenfarbe]"]')) {
      setValue('input[name="properties[Rahmenfarbe]"]', 'productapp-option', 'checked');
    }

    if (e.target.matches('input[name="properties[Ausführung]"]')) {
      setValue('input[name="properties[Ausführung]"]', 'productapp-ausführung', 'checked');
      updateTextilart();
    }

    if (e.target.matches('select[name^="properties[Auswahl Textilart"]')) {
      updateTextilart();
    }

    if (e.target.matches('select[name="properties[Druckdatenverarbeitung]"]')) {
      setValue('select[name="properties[Druckdatenverarbeitung]"]', 'productapp-druckdatenverarbeitung');
    }

    if (e.target.matches('input[name="properties[_Individuelle Maße in cm (B x H)_x]"], input[name="properties[_Individuelle Maße in cm (B x H)_y]"]')) {
      updateDimension();
    }

    if (e.target.matches('input[name="properties[_Individuelle Maße in cm (T)_x]"]')) {
      updateDimensionT();
    }

  });

  document.addEventListener('input', e => {

    if (e.target.matches('input[name="properties[INDIVIDUELLE RAL FARBE ]"]')) {
      setValue('input[name="properties[INDIVIDUELLE RAL FARBE ]"]', 'productapp-farbe');
    }

    if (e.target.matches('input[name="properties[_Individuelle Maße in cm (B x H)_x]"], input[name="properties[_Individuelle Maße in cm (B x H)_y]"]')) {
      updateDimension();
    }

    if (e.target.matches('input[name="properties[_Individuelle Maße in cm (T)_x]"]')) {
      updateDimensionT();
    }

  });

  // ================== + / - BUTTON FIX ==================
  document.addEventListener('click', e => {
    if (e.target.matches('.cl-po--quantity-btn')) {
      setTimeout(() => {
        updateDimension();
        updateDimensionT();
      }, 100);
    }
  });

  observeUploads();
}

// ================== START ==================
init();